import { Component } from '@angular/core';
import { environment } from '@environments/environment';
import { getMessaging, getToken } from 'firebase/messaging';
import { initializeApp } from 'firebase/app';
import { DashboardApiService } from '@shared/services/api/dashboard/dashboard-api.service';
import { RegistrationToken } from '@shared/services/api/dashboard/registrationtokens-service/registrationtokens-model';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/response';
import { MenuService } from 'app/core/menu/menu.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss']
})
export class LayoutComponent {

    constructor(
        private dashboardApi: DashboardApiService,
        private menuService: MenuService,
    ) {
        this.menuService.buildMenu();
        // Initialize Firebase Messaging
        if (environment.production) {
            this.initFirebaseMessaging();
        }
    }

    private async initFirebaseMessaging() {
        // Initialize Firebase
        initializeApp(environment.firebaseConfig);

        // Initialize Firebase Cloud Messaging and get a reference to the service
        const messaging = getMessaging();

        // Use default service worker, not the specific firebase one
        const serviceWorkerRegistration = await navigator.serviceWorker.getRegistration();

        // Get registration token. Initially this makes a network call, once retrieved
        getToken(messaging, { vapidKey: environment.firebaseConfig.vapidKey , serviceWorkerRegistration}).then((currentToken) => {
          if (currentToken) {
            // Store token in database
            this.dashboardApi.registrationTokens
              .addRegistrationToken(new RegistrationToken(currentToken))
              .subscribe(
                (response: SuccessResponse<boolean>) => {
                  if (!!response.data) {
                    // Registration token added to database
                  } else {
                    console.error('Registration token not added', response);
                  }
                },
                (error: ErrorResponse) => {
                  console.error('Registration token not added', error?.messages ? error?.messages[0]?.errorCode : 'NoApiResponse');
                }
              );
          } else {
            // Show permission request UI
            console.warn('No registration token available. Request permission to generate one.');
          }
        }).catch((err) => {
          console.error('An error occurred while retrieving token. ', err);
        });
      }
}
